module.exports = __webpack_public_path__ + "static/img/pickup-address-pin-grey.a95a49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/pickup-address-pin-grey.png
// module id = rsN6
// module chunks = 0